module.exports = __webpack_public_path__ + "6cdc5c71ebea4343cf95e13ff651f5f7.svg";